import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import {
  SupplierList,
  ModalSupplierForm,
  SupplierModel,
  listSuppliers,
  createSupplier,
  updateSupplier,
} from '../../modules/suppliers';
import { toast } from 'react-toastify';

const SuppliersPage: FC = () => {
  const intl = useIntl();
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalSupplierFormVisible, setModalSupplierFormVisible] =
    useState(false);
  const [editingSupplier, setEditingSupplier] = useState<
    SupplierModel | undefined
  >(undefined);

  const fetchSuppliers = async () => {
    try {
      setLoading(true);
      const { data } = await listSuppliers();
      setSuppliers(data);
    } catch (error) {
      console.warn(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  function onAddSupplier() {
    setEditingSupplier(undefined);
    setModalSupplierFormVisible(true);
  }

  async function onSaveSupplier(supplier: SupplierModel) {
    setModalSupplierFormVisible(false);
    setLoading(true);
    try {
      if (supplier.id) {
        const response = await updateSupplier(supplier);
        setSuppliers([
          ...suppliers.filter((s) => s.id !== supplier.id),
          response.data,
        ]);
      } else {
        const response = await createSupplier(supplier);
        setSuppliers([...suppliers, response.data]);
      }
      fetchSuppliers();
      toast.success(intl.formatMessage({ id: 'suppliers.saved' }));
    } catch (error) {
      if (Object.entries(error?.response?.data)?.length > 0) {
        /* Object.entries(error?.response?.data).forEach(([key, value]) => {
          toast.error(`${key}: ${value}`);
        }); */
      } else {
        toast.error(intl.formatMessage({ id: 'suppliers.errorSaving' }));
      }

      console.warn(error);
    } finally {
      setLoading(false);
    }
  }

  async function onRemoveSupplier(supplier: SupplierModel) {
    const hasConfirmed = window.confirm(
      intl.formatMessage({ id: 'suppliers.confirmRemove' })
    );
    if (!hasConfirmed) {
      return;
    }

    setLoading(true);
    try {
      await updateSupplier({ ...supplier, state: 'inactive' });
      setSuppliers(suppliers.filter((s) => s.id !== supplier.id));
      fetchSuppliers();
      toast.success(intl.formatMessage({ id: 'suppliers.removed' }));
    } catch (error) {
      console.warn(error);
      toast.error(intl.formatMessage({ id: 'suppliers.errorRemoving' }));
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'menu.suppliers' })}
      </PageTitle>
      <div className="row">
        <div className="col-12">
          <div className="card p-10">
            <SupplierList
              suppliers={suppliers}
              loading={loading}
              onAddSupplier={onAddSupplier}
              onRemoveSupplier={onRemoveSupplier}
            />
            <ModalSupplierForm
              supplier={editingSupplier}
              visible={modalSupplierFormVisible}
              onCancel={() => setModalSupplierFormVisible(false)}
              onSaveSupplier={onSaveSupplier}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export { SuppliersPage };
